import { useLingui } from '@lingui/react/macro';
import {
  DialogHeader,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';

import type { InsuranceView } from '../../insuranceExport/constants';

export function SummaryHeader({ insView }: { insView: InsuranceView }) {
  const { t } = useLingui();
  const getTitle = () => {
    if (insView === 'config') {
      return t`Create Claim Summary`;
    }
    if (insView === 'preview-pages' || insView === 'preview-single') {
      return t`Image Summary`;
    }
    if (insView === 'narrative-dev-tool') {
      return t`AI Config`;
    }
    return t`Claim Summary`;
  };
  return (
    <DialogHeader>
      <DialogTitle data-testid="claim-summary-header-title">
        {getTitle()}
      </DialogTitle>
    </DialogHeader>
  );
}
